import React from 'react';
import { Router } from '@reach/router';

import Dashboard from './Dashboard';
import Transaction from './Transaction';
import Container from './Container';

export default () => (
  <Container>
    <Router>
      <Dashboard path="/*" />
      <Transaction path="transaction/*" />
    </Router>
  </Container>
);
